<form
  (submit)="onSubmit()"
  [class.dirty-and-invalid-or-invalid-submitted]="
    (form.controls['readInformationCheckbox'].dirty &&
      form.controls['readInformationCheckbox'].invalid) ||
    (form.invalid && submitted)
  "
  [formGroup]="form"
>
  <app-card
    [title]="'company.group_info.your_company' | translate"
    [subtitle]="'company.group_info.group_description' | translate"
    imagename="placeholder-avatar.png"
  ></app-card>

  <app-infobox>
    <p style="line-height: normal">
      {{ 'company.group_info.info_text_1' | translate
      }}<strong>{{ 'company.group_info.info_text_strong' | translate }}</strong
      >{{ 'company.group_info.info_text_2' | translate }}
    </p>
  </app-infobox>
  <app-checkbox-input
    [label]="'company.group_info.confirmation_text' | translate"
    [controllerName]="'readInformationCheckbox'"
    [validators]="[Validators.requiredTrue]"
  ></app-checkbox-input>
  <app-response-banner
    [success]="false"
    [invisible]="!submitted"
    [errorMessage]="'company.group_info.confirm_conditions' | translate"
  ></app-response-banner>
  <app-button
    [title]="'company.group_info.create_new' | translate"
  ></app-button>
</form>
